import { render, staticRenderFns } from "./CyclingGame.vue?vue&type=template&id=4567aeee&"
import script from "./CyclingGame.vue?vue&type=script&lang=js&"
export * from "./CyclingGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports